import { createTheme } from "@mui/material";
const theme=createTheme({
palette:{
    primary:{
        main:'#8A5FF7',
    },
    secondary:{
        main:'#8761ea',
    },
    info:{
        main:'#0090B7',
    },
    success:{
        main:'#00C9A5',
    },
    warning:{
        main:'#F9F871',
    },
},  
})
export default theme;